<app-message
    [successMessage]="false"
    [messageTitle]="'messages.change-password-failed.title' | translate"
    [message]="'messages.change-password-failed.description' | translate"
>
</app-message>
